
import { useMutation } from "@tanstack/react-query";
import toast from 'react-hot-toast';
import axios from '../lib/axios';

export const useGetProfileData = () => {
    return useMutation({
        mutationKey: ['getProfileDataGet'],
        mutationFn: async () => {
            const response = await axios.post("v2/getuserprofile");
            return response.data;

        }
    })
}


export const useUpdateProfileDetail = () => {
    return useMutation({
        mutationKey: ["updateProfileSetting"],
        mutationFn: async (profileData) => {
            const response = await axios.post("v2/updateprofile", profileData);
            return response.data;
        },
        onSuccess: (data) => {
            toast.success(data.message);            
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Update failed");
        },
    });
};
